import { sizes } from '../style';

export const SIZE_S = Symbol('SIZE_S');
export const SIZE_M = Symbol('SIZE_M');
export const SIZE_L = Symbol('SIZE_L');

export function getSizeData(size, onlyIcon) {
  switch (size) {
    case SIZE_S:
      return {
        iconSize: 16,
        buttonSizeClassName: onlyIcon ? sizes['s-icon-only'] : sizes.s,
      };
    case SIZE_M:
      return {
        iconSize: 18,
        buttonSizeClassName: onlyIcon ? sizes['m-icon-only'] : sizes.m,
      };
    case SIZE_L:
      return {
        iconSize: 22,
        buttonSizeClassName: onlyIcon ? sizes['l-icon-only'] : sizes.l,
      };
    default:
      throw new Error(`Unknown size ${String(size)}`);
  }
}

export default [SIZE_S, SIZE_M, SIZE_L];
